import { FeeAccountIcon, type IconComponent } from '@infinex/ui-icons';

import { getCustodyIcon } from '../../utils';
import type { CustodyIconType } from '../custody';

export type SendToWalletIconType = CustodyIconType | 'gas-account' | 'others';
const Noop = () => <></>;

export const getTargetWalletIcon = (
  type: SendToWalletIconType
): IconComponent => {
  if (type === 'gas-account') {
    return FeeAccountIcon;
  }
  if (type === 'others') {
    return Noop;
  }
  return getCustodyIcon(type);
};
